<template>
  <div class="mt-12 bg-blue-200 p-6">

    <h2>{{ block.title }}</h2>
    <div v-html="block.content"></div>

    <div v-if="!answer_submitted" class="mt-8 flex justify-center">
      <button v-if="!answer_submitted" @click="submit_results"
              class="px-4 py-3 text-white rounded-sm"
              :class="{ 'bg-green-500': !answer_submitted,
                        'bg-gray-300': answer_submitted }">
        Ihre Antworten abgeben
      </button>
      <!--
      {{ calc_subject_quiz_result( block.subject_id ) }}
      -->
    </div>

    <div v-if="answer_submitted && result_reached" class="text-center">

      <p>
        Gratulation! Sie haben ein Ergebnis von
        <strong class="text-xl">{{ reached_percent }}%</strong> erreicht.
      </p>

      <button v-if="false && result_reached" @click="send_result"
              class="mt-4 px-4 py-3 text-white rounded-sm bg-blue-500">
        Ergebnis an Personalberater weiterleiten?
      </button>

      <button @click="reset_quizes" class="mt-4 self-center px-4 py-3 text-white bg-blue-400">
        Möchten Sie es erneut versuchen?
      </button>

    </div>

    <div v-if="answer_submitted && !result_reached"  class="text-center">
      <p>
        <strong>Leider.</strong> Sie haben bei diesem Versuch
        <strong class="text-xl">{{ reached_percent }}%</strong> von den erforderlichen
        <strong class="text-xl">{{ block.options.quiz_minimum_percent }}%</strong> erreicht.
      </p>
      <button @click="reset_quizes" class="mt-4 self-center px-4 py-3 text-white bg-blue-400">
        Möchten Sie es erneut versuchen?
      </button>
    </div>

    <SendResultWindow v-if="( answer_submitted && result_reached ) || test"
                      class="mt-4"
                      :subject_id="block.subject_id"></SendResultWindow>

    <pre v-if="debug">
      BLOCK
      {{ block }}

      QUIZ_BLOCKS_STATUS
      {{ quiz_blocks_status }}

      RESULT
      {{ calc_subject_quiz_result( block.subject_id ) }}
    </pre>
  </div>
</template>

<script>

import SendResultWindow from '../send_result_window.vue'

import EventBus from '../../api/event-bus'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  props: [ 'block' ],
  data() {
    return {
      test: false,
      debug: false,
      answer_submitted: false,
      question_counter: 0,
      reached_percent: 0.0
    }
  },
  computed: {
    ...mapState([,'quiz_blocks_status']),
    ...mapGetters(['calc_subject_quiz_result', 'subject_quiz_blocks_status']),
    result_reached() {
      if( ! this.answer_submitted ) return false
      return this.reached_percent >= this.block.options.quiz_minimum_percent
    }
  },
  methods: {
    ...mapActions(['update_quiz_status', 'reset_quiz_blocks']),
    async submit_results() {
      EventBus.emit('submit_result')

      // console.log( this.subject_quiz_blocks_status( this.block.subject_id ) )

      const x = this.calc_subject_quiz_result( this.block.subject_id )
      this.reached_percent = x['result']
      this.answer_submitted = true
    },
    reset_quizes() {
      // reset only quiz components
      EventBus.emit('reset_result')

      // reset also the quiz_blocks
      this.reset_quiz_blocks( this.block.subject_id )

      this.question_counter = 0
      this.reached_percent = 0.0
      this.answer_submitted = false
    },
    send_result() {
      EventBus.emit( 'display-send-result-window', this.block.subject_id )
    }
  },
  created() {
    EventBus.emit( 'display_submit', false )

    // console.log( this.subject_quiz_blocks_status( this.block.subject_id ) )
    // let w = x.some( q => { console.log( q ); return q.done } )
    let x = this.calc_subject_quiz_result( this.block.subject_id )
    // console.log( x )
    this.reached_percent = x['result']
    this.answer_submitted = x['done'] > 0
  },
  components: {
    SendResultWindow
  }
}
</script>